import React, { useId } from 'react';

export default function SoundBasketArt() {
  const id = useId();
  return <svg className="sound-basket-art" viewBox="0 0 300 250" aria-hidden="true">
    <defs>
      <linearGradient id={`${id}-body`} x1="0" y1="0" x2="0" y2="1">
        <stop stopColor="#efbd78" /><stop offset="1" stopColor="#d9984e" />
      </linearGradient>
      <clipPath id={`${id}-clip`}><path d="M32 102H268L245 218Q150 252 55 218Z" /></clipPath>
    </defs>
    <ellipse cx="150" cy="235" rx="112" ry="11" fill="#50301c" opacity=".12" />
    <path d="M67 112V84C67 0 233 0 233 84V112" fill="none" stroke="#ae6b32" strokeWidth="20" />
    <path d="M67 109V84C67 0 233 0 233 84V109" fill="none" stroke="#efbd78" strokeWidth="11" />
    <ellipse cx="150" cy="104" rx="119" ry="26" fill="#a06535" stroke="#bb7a3c" strokeWidth="7" />
    <ellipse cx="150" cy="106" rx="102" ry="15" fill="#754926" />
    <path d="M32 102H268L245 218Q150 252 55 218Z" fill={`url(#${id}-body)`} stroke="#bb7a3c" strokeWidth="5" />
    <g clipPath={`url(#${id}-clip)`} fill="none" stroke="#b77a3d" strokeWidth="4" opacity=".55">
      {[65,100,135,170,205,240].map((x) => <path key={x} d={`M${x} 106L${150 + (x - 150) * .8} 238`} />)}
      {[128,155,182,209,236].map((y) => <path key={y} d={`M35 ${y}Q150 ${y + 18} 265 ${y}`} />)}
    </g>
    <path d="M34 104Q150 139 266 104" fill="none" stroke="#f5ce92" strokeWidth="13" strokeLinecap="round" />
    <path d="M55 217Q150 250 245 217" fill="none" stroke="#bc7d3f" strokeWidth="8" strokeLinecap="round" />
  </svg>;
}
